import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'gatsby-link';
import Search from '../Search/Search';
import Menu from '../Menu/Menu';
import { getScrollTop } from '../../shared/utils';
import logoLandscape from './logo-landscape.svg';
import logoPortrait from './logo-portrait.svg';
import './header.scss';

const FontFaceObserver = require('fontfaceobserver');

const COMPACT_TRESHOLD = 23; // (full_height - logo_height) / 2

const apercu = new FontFaceObserver('Apercu', {
  weight: 300
});

class Header extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    backgroundColor: PropTypes.string
  };

  static defaultProps = {
    backgroundColor: '#222'
  };

  constructor(props) {
    super(props);

    this.nav = React.createRef();

    this.fontLoaded = false;

    this.openSearch = this.openSearch.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.highlightActiveMenuItem = this.highlightActiveMenuItem.bind(this);
    this.onMouseEnterMenuItem = this.onMouseEnterMenuItem.bind(this);

    this.init();
  }

  state = {
    barX: 'translateX(-20px)',
    barWidth: 0,
    search: false,
    menu: false,
    compact: false
  };

  componentDidMount() {
    window.addEventListener('resize', this.highlightActiveMenuItem);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.highlightActiveMenuItem);
    window.removeEventListener('scroll', this.handleScroll);
  }

  onMouseEnterMenuItem(e) {
    const currentTargetRect = e.currentTarget.getBoundingClientRect();
    const left = currentTargetRect.left - this.nav.current.getBoundingClientRect().left;
    this.setState({
      barX: `translateX(${left}px)`,
      barWidth: currentTargetRect.width
    });
  }

  getActiveNavItem() {
    const activeNavItem =
      this.nav.current.querySelector('a.current') && this.nav.current.querySelector('a.current').parentElement;
    const firstNavItem =
      this.nav.current.querySelector('a:first-of-type') && this.nav.current.querySelector('li:first-of-type');
    return activeNavItem || firstNavItem;
  }

  init() {
    if (typeof window !== 'undefined') {
      apercu.load().then(() => {
        const activeNavItem = this.getActiveNavItem();
        const activeNavItemRect = activeNavItem.getBoundingClientRect();
        this.fontLoaded = true;
        const left = activeNavItemRect.left - this.nav.current.getBoundingClientRect().left;
        this.setState({
          barX: `translateX(${left}px)`,
          barWidth: activeNavItemRect.width
        });
      });
    }
  }

  handleScroll() {
    const scrollTop = getScrollTop();
    this.setState({
      compact: scrollTop > COMPACT_TRESHOLD
    });
  }

  highlightActiveMenuItem() {
    const activeNavItem = this.getActiveNavItem();
    const activeNavItemRect = activeNavItem.getBoundingClientRect();
    const left = activeNavItemRect.left - this.nav.current.getBoundingClientRect().left;
    this.setState({
      barX: `translateX(${left}px)`,
      barWidth: activeNavItemRect.width
    });
  }

  openMenu() {
    this.setState({ menu: true });
  }

  closeMenu() {
    this.setState({ menu: false });
  }

  openSearch() {
    this.setState({ search: true });
  }

  closeSearch() {
    this.setState({ search: false });
  }

  render() {
    const barStyles = {
      /* stylelint-disable */
      transform: this.state.barX,
      width: this.state.barWidth
    };

    const headerStyles = {
      backgroundColor: this.state.compact ? this.props.backgroundColor : 'transparent'
    };

    const tags = new Set();
    const allTags = this.props.data.allTags
      ? this.props.data.allTags.edges
          .map(({ node }) => node.frontmatter.tags)
          .reduce((acc, val) => acc.concat(val), [])
      : [];

    allTags.forEach(tag => {
      tags.add(tag);
    });

    return (
      <Fragment>
        <header className={classNames('header', { compact: this.state.compact })} style={headerStyles}>
          <div className="header-inner layout">
            <div className="header-menu">
              <button
                className={classNames('hamburger', 'hamburger--slider', { 'is-active': this.state.menu })}
                onClick={this.openMenu}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </button>
            </div>
            <nav className="header-nav" ref={this.nav}>
              <ul className={classNames('header-links', { in: this.fontLoaded })}>
                <li onMouseEnter={this.onMouseEnterMenuItem} onMouseLeave={this.highlightActiveMenuItem}>
                  <Link
                    to="/works"
                    activeClassName="current"
                    isActive={(match, location) => 
                      location.pathname === '/' || 
                      location.pathname.startsWith('/works') ||
                      location.pathname.startsWith('/cn/works')}
                  >
                    WORK
                  </Link>
                </li>
                <li onMouseEnter={this.onMouseEnterMenuItem} onMouseLeave={this.highlightActiveMenuItem}>
                  <Link to="/about" activeClassName="current">
                    ABOUT
                  </Link>
                </li>
                <li onMouseEnter={this.onMouseEnterMenuItem} onMouseLeave={this.highlightActiveMenuItem}>
                  <Link to="/contact" activeClassName="current">
                    CONTACT
                  </Link>
                </li>
              </ul>
              <i className="bar" style={barStyles} />
            </nav>
            <div className="brand">
              <Link to="/">
                <img src={this.state.compact ? logoLandscape : logoPortrait} alt="flatwhite logo" />
              </Link>
            </div>
            <div className="header-search-left-padding" />
            <button className={classNames('header-search', { in: this.fontLoaded })} onClick={this.openSearch}>
              <i className="fas fa-search" />
            </button>
          </div>
        </header>
        <div className="header-padding" />
        <Search tags={tags} in={this.state.search} onClose={this.closeSearch} />
        <Menu in={this.state.menu} onClose={this.closeMenu} />
      </Fragment>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx